
import { eEstadoUsuario, TipoUsuario } from "../common/enumModel";
import { IFilterUsuarioModel } from "../interfaces/seguridad/IFilterUsuarioModel";
import { TipoUsuarioModel } from "../usuario/TipoUsuarioModel";

export class FilterUsuarioModel implements IFilterUsuarioModel {    
    usuario: string;
    idUsuarios: string[];
    idTipoUsuario: TipoUsuario;
    page: number;
    pageSize: number;
    correo: string;
    idSede?: number;
    idRol?: number;
    idCompania?: number;
    idEstado: number;

    constructor(){
        this.idTipoUsuario = TipoUsuario.Empleado;
        this.idUsuarios = new Array<string>();
        this.usuario = '';
        this.pageSize = 100;
        this.page = 1;
        this.correo = '';
        this.idEstado = eEstadoUsuario.TODOS;
    }
}